import { render, staticRenderFns } from "./wx-payment-edit.vue?vue&type=template&id=5ca72f0a&scoped=true&"
import script from "./wx-payment-edit.vue?vue&type=script&lang=js&"
export * from "./wx-payment-edit.vue?vue&type=script&lang=js&"
import style0 from "./wx-payment-edit.vue?vue&type=style&index=0&id=5ca72f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca72f0a",
  null
  
)

export default component.exports